var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { UPDATE_STORE_INFO, } from "actions/online_ordering/store_info";
var initialState = {
    permalink: "",
    apiUsername: "",
    locationUrl: "",
    locationName: "",
    description: "",
    phoneNumber: "",
    integrationStatus: "",
    orderTakingStatus: "",
    deliveryFee: 0,
    deliveryFeeTaxRateId: "",
    deliveryMinimumOrder: "",
    deliveryZips: [],
    deliveryGeojson: "",
    deliveryMapSettings: "",
    timezone: "",
    ugMerchantKey: "",
    address: {
        line1: "",
        line2: "",
        city: "",
        state: "",
        zip: "",
    },
    fulfillmentTypes: [],
    latitude: "",
    longitude: "",
    published: false,
    futureOrder: false,
    orderReadyBy: 0,
    deliveryOrderReadyBy: 0,
    deliveryOrderReadyByMax: 0,
    pickupOrderReadyBy: 0,
    pickupOrderReadyByMax: 0,
    settings: {
        collapseGroupsByDefault: false,
        headerImageUrl: "",
    },
    mapUrl: "",
};
function storeInfo(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case UPDATE_STORE_INFO: {
            return __assign({}, action.storeInfo);
        }
        default: {
            return state;
        }
    }
}
export default storeInfo;
